import { render } from "./EditCodecsiView.vue?vue&type=template&id=6d1a507e"
import script from "./EditCodecsiView.vue?vue&type=script&lang=js"
export * from "./EditCodecsiView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__